import Vue from "vue";
import Vuex from "vuex";
import showMySlide from './showMySlide.module';

Vue.use(Vuex);

const getDefaultTimelineState = () => {
    return {
        id: null,
        nome: "",
        itemEmEdicaoIndex: null,
        layoutDivisaoNumeroEmEdicao: null,
        meioElementoEmEdicaoIndex: null, //usado p/ elementos do meio do cartaz
        tempoExibicao: 6,
        itens: {},
    };
}

const domain = 'https://digitab.com.br';

export default new Vuex.Store({
    modules: {
        showMySlide
    },

    state: {
        domain: domain,
        serverUrl: "/api/v1",
        // serverImgUserPath: "imagensUsuario",
        serverImgUserPath: "imagensUsuario",
        timelineMainContainerSize: {
            w: 0,
            h: 0
        },
        timelineStore: getDefaultTimelineState(),
        modoExibicaoSlides: null //edicao(usuario logado alterando) ou player
    },

    mutations: {
        resetTimelineState(state) {
            Object.assign(state.timelineStore, getDefaultTimelineState())
        },

        setModoExibicaoSlides(state, modo) {
            state.modoExibicaoSlides = modo;
        },

        setTimelineState(state, json) {
            Object.assign(state.timelineStore, json)
        },

        setTimelineId(state, id) {
            state.timelineStore.id = id;
        },

        setTimelineNome(state, v) {
            state.timelineStore.nome = v;
        },

        setTimelineTempoExibicao(state, v) {
            state.timelineStore.tempoExibicao = v;
        },

        addTimelineItem(state, item) {
            let itemUID = 'UID_' + (new Date().getTime());
            // let itemUID = 'UID_' + (new Date().getTime()) + '_' + (Math.floor(Math.random() * 2147483647) + 1);
            state.timelineStore.itemEmEdicaoIndex = itemUID;
            // state.timelineStore.itens[itemUID] = item;

            let newItem = {};
            newItem[itemUID] = item;

            state.timelineStore.itens = Object.assign({}, state.timelineStore.itens, newItem);

            // state.timelineStore.itens.push(item);
            // state.timelineStore.itemEmEdicaoIndex = state.timelineStore.itens.length - 1;
            state.timelineStore.layoutDivisaoNumeroEmEdicao = 1;
        },

        addCartazMeioElemento(state, elemento) {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            let dIndex = state.timelineStore.layoutDivisaoNumeroEmEdicao;

            let els = state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos;
            els.push(elemento);

            // state.timelineStore.meioElementoEmEdicaoIndex = state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos.length - 1;
        },

        rmCartazMeioElemento(state, i) {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            let dIndex = state.timelineStore.layoutDivisaoNumeroEmEdicao;

            state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos.splice(i, 1);

            state.timelineStore.meioElementoEmEdicaoIndex = state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos.length - 1;
        },

        setTimelineItemEmEdicaoIndexEmEdicao(state, i) {
            state.timelineStore.itemEmEdicaoIndex = i;
        },

        setTimelineDivisaoNumeroEmEdicao(state, divisaoNumero) {
            state.timelineStore.layoutDivisaoNumeroEmEdicao = divisaoNumero;
        },

        setMeioElementoEmEdicaoIndex(state, i) {
            state.timelineStore.meioElementoEmEdicaoIndex = i;
        },

        setTimelineDadosComponente(state, obj) {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            let dIndex = state.timelineStore.layoutDivisaoNumeroEmEdicao;

            /////////////////////////////////////////////////////////////
            let configsTabelaPreco = {
                divisaoTelaCheia: false,
                divisaoStyle: {
                    "background-color": "#FFFFFFFF",
                },

                cabecalhoExibir: true,
                cabecalhoTextoClass: {
                    // size: "text-h3",
                    align: "text-center",
                    decoration: "",
                    weight: "",
                    italic: "",
                    estilo: [],
                },
                cabecalhoImg: "",
                cabecalhoStyle: {
                    color: "#000000FF",
                    "background-color": "#FFFFFFFF",
                    "text-align": "center",
                    fontFamily: "'roboto', sans-serif",
                    fontSize: '6'
                },

                tHeadExibir: true,
                tHeadTextoClass: {
                    // size: "text-h4",
                    decoration: "",
                    weight: "",
                    italic: "",
                    estilo: [],
                },
                tHeadStyle: {
                    color: "#000000FF",
                    "background-color": "#FFFFFFFF",
                    "text-align": "left",
                    fontFamily: "'roboto', sans-serif",
                    fontSize: '5.5'
                },

                tBodyTextoClass: {
                    // size: "",
                    decoration: "",
                    weight: "",
                    italic: "",
                    estilo: [],
                },
                tBodyStyle: {
                    color: "#000000FF",
                    "background-color": "#FFFFFFFF",
                    "text-align": "left",
                    fontFamily: "'roboto', sans-serif",
                    fontSize: '5.5'
                },

                destaqueExibir: true,
                destaqueTexto: "oferta!",
                destaqueIcone: "",
                destaqueIconePosition: "left",
                destaqueRounded: true,
                destaqueOutlined: false,
                destaqueStyle: {
                    color: "#000000FF",
                    "background-color": "#FFFFFFFF",
                },
            };

            let configsCartaz = {
                //divisao
                divisaoTelaCheia: false,
                divisaoStyle: {
                    "background-color": "#FFFFFFFF",
                },

                //cabeçalho
                // cabecalhoTexto: "",
                // cabecalhoTextoClass: {
                //     size: "text-h3",
                //     align: "text-center",
                //     decoration: "",
                //     weight: "",
                //     italic: "",
                //     estilo: [],
                // },
                // cabecalhoImg: "",
                // cabecalhoStyle: {
                //     color: "#000000FF",
                //     "background-color": "#FFFFFF00",
                //     "text-align": "center",
                //     fontFamily: "'roboto', sans-serif",
                // },

                //meio
                // meioImg: "",
                // meioStyle: {
                //     "background-color": "#FFFFFF00",
                // },
                meioElementos: [
                    //exemplo do obj da estrutura das cfgs de elementos
                    //em getEstruturaElementosMeioCartaz neste mesmo arquivo
                ],

                //rodapé
                // rodapeTexto: "",
                // rodapeTextoClass: {
                //     size: "text-h3",
                //     align: "text-center",
                //     decoration: "",
                //     weight: "",
                //     italic: "",
                //     estilo: [],
                // },
                // rodapeImg: "",
                // rodapeStyle: {
                //     color: "#000000FF",
                //     "background-color": "#FFFFFF00",
                //     "text-align": "center",
                //     fontFamily: "'roboto', sans-serif",
                // },

            };
            /////////////////////////////////////////////////////////////

            state.timelineStore.itens[iIndex].layoutDivisoes[dIndex] = {
                quadroIndex: iIndex,
                divisaoNumero: dIndex,
                componenteTipo: obj.componenteTipo,
                componenteDados: obj.componenteDados,
                configs: {},
            };

            let configsCopy = {};
            switch (obj.componenteTipo) {
                case "tabela-preco":
                    configsCopy = Object.assign({}, configsTabelaPreco);
                    state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs = configsCopy;
                    break;

                case "cartaz":
                    configsCopy = Object.assign({}, configsCartaz);

                    //quando o usuario seleciona um modelo de cartaz pre pronto
                    //faz merge das cfgs, pois se caso vier do db faltando algo, nao vai dar erro no front
                    if (typeof obj.configs != "undefined") {
                        configsCopy = Object.assign(configsCopy, obj.configs);
                    }

                    state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs = configsCopy;
                    break;
            }
        },

        setDivisaoConfigs(state, configs) {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            let dIndex = state.timelineStore.layoutDivisaoNumeroEmEdicao;

            state.timelineStore.itens[iIndex].layoutDivisoes[dIndex] = {
                ...state.timelineStore.itens[iIndex].layoutDivisoes[dIndex],
                configs: configs
            };
        },

        setMeioElementoConfigsByIndex(state, obj) {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            let dIndex = state.timelineStore.layoutDivisaoNumeroEmEdicao;

            state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos[obj.index]
                =
                Object.assign(
                    state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos[obj.index],
                    obj.el
                )
            ;
        },

        setTimelineMainContainerSize(state, obj) {
            state.timelineMainContainerSize.w = obj.w;
            state.timelineMainContainerSize.h = obj.h;
        }
    },
    getters: {
        getEstruturaDivisoes: state => {
            //define as divisoes do layout de acordo com o tipo dele
            let layoutDivisoes = {};
            let divisaoStructure = {
                quadroIndex: null,
                divisaoNumero: null,
                componenteTipo: "", //tabela-preco, cartaz...
                componenteDados: {},
                configs: {},
            };

            //setando sempre a qtd do layout q tem mais divisões para todos para evitar o undefined
            let qtdDivisoes = 3;
            for (let i = 0; i < qtdDivisoes; i++) {
                let divisaoStructureCopy = Object.assign({}, divisaoStructure);
                layoutDivisoes[(i + 1)] = divisaoStructureCopy;
            }
            //fim - define as divisoes do layout de acordo com o tipo dele

            return layoutDivisoes;
        },

        /*
        * estrutura de um elemento
        */
        getEstruturaElementosMeioCartaz: state => {
            return {
                tipo: "", //pode ser mercadoria, tabela-preco, texto ou imagem(e video)
                conteudo: "", //id da mercadoria, id da tabela de preços, texto ou nome unico da imagem
                nomeOriginal: "", //nome original da imagem
                mercDataAux: {},
                mercOptions: {
                    exibirCodigo: false,
                    exibirPreco: true,
                },

                class: {
                    align: "text-center",
                    decoration: "",
                    weight: "",
                    italic: "",
                    estilo: [],
                },
                style: {
                    color: "#000000FF",
                    "background-color": "#FFFFFF00",
                    "text-align": "center",
                    fontFamily: "'roboto', sans-serif",
                },

                tabelaPrecoDataAux: {},
                tabelaPrecoOptions: {
                    tabelaStyle: {
                        backgroundColor: "#FFFFFFFF",
                    },
                    cabecalhoExibir: false,
                    cabecalhoTextoClass: {
                        align: "text-center",
                        decoration: "",
                        weight: "",
                        italic: "",
                        estilo: [],
                    },
                    cabecalhoStyle: {
                        color: "#000000FF",
                        backgroundColor: "#FFFFFFFF",
                        textAlign: "center",
                        fontFamily: "'roboto', sans-serif",
                        fontSize: '6'
                    },

                    tHeadExibir: false,
                    tHeadTextoClass: {
                        decoration: "",
                        weight: "",
                        italic: "",
                        estilo: [],
                    },
                    tHeadStyle: {
                        color: "#000000FF",
                        backgroundColor: "#FFFFFFFF",
                        textAlign: "left",
                        fontFamily: "'roboto', sans-serif",
                        fontSize: '5.5'
                    },

                    tBodyTextoClass: {
                        decoration: "",
                        weight: "",
                        italic: "",
                        estilo: [],
                    },
                    tBodyStyle: {
                        color: "#000000FF",
                        backgroundColor: "#FFFFFF00",
                        textAlign: "left",
                        fontFamily: "'roboto', sans-serif",
                        fontSize: '5.5'
                    },

                    destaqueExibir: true,
                    destaqueTexto: "promoção!",
                    destaqueIcone: "",
                    destaqueIconePosition: "left",
                    destaqueRounded: true,
                    destaqueOutlined: false,
                    destaqueStyle: {
                        color: "#000000FF",
                        backgroundColor: "#FFFFFF00",
                    },
                },

                draggable: {
                    w: 100,
                    h: 100,
                    x: 1,
                    y: 1,
                    zIndex: 10,
                    wPerc: 0,
                    hPerc: 0,
                    xPerc: 0,
                    yPerc: 0,
                }
            };
        },

        getDivisoes: (state, getters) => {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            if (typeof state.timelineStore.itens[iIndex] != 'undefined') {
                return state.timelineStore.itens[iIndex].layoutDivisoes;
            } else {
                return getters.getEstruturaDivisoes;
            }
        },

        getItemEmEdicao: state => {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            return state.timelineStore.itens[iIndex];
        },

        getDivisaoEmEdicao: state => {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            let dIndex = state.timelineStore.layoutDivisaoNumeroEmEdicao;

            if (typeof state.timelineStore.itens[iIndex] != "undefined"
                && typeof state.timelineStore.itens[iIndex].layoutDivisoes[dIndex] != "undefined") {

                return state.timelineStore.itens[iIndex].layoutDivisoes[dIndex];
            } else {
                return null;
            }
        },

        //utilizado para elementos do meio do cartaz
        getMeioElementosDaDivisao: state => {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            let dIndex = state.timelineStore.layoutDivisaoNumeroEmEdicao;
            let eIndex = state.timelineStore.meioElementoEmEdicaoIndex;

            if (typeof state.timelineStore.itens[iIndex] != "undefined"
                && typeof state.timelineStore.itens[iIndex].layoutDivisoes[dIndex] != "undefined"
                && typeof state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos.length
            ) {
                return state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos;
            } else {
                return null;
            }
        },

        getMeioElementoEmEdicao: state => {
            let iIndex = state.timelineStore.itemEmEdicaoIndex;
            let dIndex = state.timelineStore.layoutDivisaoNumeroEmEdicao;
            let eIndex = state.timelineStore.meioElementoEmEdicaoIndex;

            if (typeof state.timelineStore.itens[iIndex] != "undefined"
                && typeof state.timelineStore.itens[iIndex].layoutDivisoes[dIndex] != "undefined"
                && typeof state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos[eIndex] != "undefined"
            ) {
                return state.timelineStore.itens[iIndex].layoutDivisoes[dIndex].configs.meioElementos[eIndex];
            } else {
                return null;
            }
        },

        getUsrEndpoint: state => {
            let user = localStorage.getItem('user');
            user = JSON.parse(user);

            return '/usuarios/' + user.id;
        }
    },
    actions: {
        addTimelineItem({commit, getters}, item) {
            let layoutDivisoes = getters.getEstruturaDivisoes;
            item.layoutDivisoes = Object.assign({}, layoutDivisoes);
            commit('addTimelineItem', item);
        },

        addCartazMeioElemento({commit, getters, state}, elemento) {
            let estrutura = getters.getEstruturaElementosMeioCartaz;
            estrutura = JSON.parse(JSON.stringify(estrutura));

            // let estrutura = Object.assign({}, getters.getEstruturaElementosMeioCartaz);
            estrutura = Object.assign(estrutura, elemento);

            commit('addCartazMeioElemento', estrutura);

            //-------------------------------------------------
            //ajusta os percentuais de x, y, w e h já no momento q adiciona o elemento
            let elementoIndex = state.timelineStore.meioElementoEmEdicaoIndex; //indice do elemento recem added
            let el = getters.getMeioElementosDaDivisao[elementoIndex];

            let xPerc = (el.draggable.x / state.timelineMainContainerSize.w);
            let yPerc = (el.draggable.y / state.timelineMainContainerSize.h);
            let wPerc = (el.draggable.w / state.timelineMainContainerSize.w);
            let hPerc = (el.draggable.h / state.timelineMainContainerSize.h);

            el.draggable.xPerc = xPerc;
            el.draggable.yPerc = yPerc;
            el.draggable.wPerc = wPerc;
            el.draggable.hPerc = hPerc;

            commit('setMeioElementoConfigsByIndex', {el: el, index: elementoIndex});
            //-------------------------------------------------
        },
    },
});
